<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="100px">
            <el-form-item label="网页地址" prop="webAddress">
                <el-input v-model.trim="searchForm.webAddress" maxlength="100"
                          placeholder="请输入网页地址(限100字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="网页名称" prop="webName">
                <el-input v-model.trim="searchForm.webName" maxlength="50"
                          placeholder="请输入网页名称(限50字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="webState">
                <el-switch
                        v-model="searchForm.webState"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
            <div v-show="title == '编辑网页资源'">
                <el-form-item label="添加人" prop="type">
                    <div>{{ searchForm.createByName }}</div>
                </el-form-item>
                <el-form-item label="添加时间" prop="type">
                    <div>{{ searchForm.createDate }}</div>
                </el-form-item>
                <el-form-item label="最后修改时间" prop="type">
                    <div>{{ searchForm.updateDate }}</div>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addNatural",
    data() {
        return {
            title: '新增网页资源',
            visible: false,
            searchForm: {
                webAddress: '',
                webName: '',
                webState: '0',
            },
            rules: {
                webAddress: [
                    {required: true, message: '请输入网页地址', trigger: 'blur'}
                ],
                webName: [
                    {required: true, message: '请输入网页名称', trigger: 'blur'}
                ],
            },
        }
    },

    methods: {
        init(num, row) {
            this.searchForm = {
                webAddress: '',
                webName: '',
                webState: '0',
            }
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (num == 0) {
                this.title = '新增网页资源'
            }
            if (num == 2) {
                this.title = '编辑网页资源'
                this.$axios(this.api.academic.webresourceGetById + row.id, {}).then(data => {
                    if (data && data.status) {
                        this.searchForm = data.data
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.webresourceUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.webresourceSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>